import React, {
  Fragment,
  useState,
  useEffect,
  useCallback,
  useContext,
} from "react";
import { Btn, H3 } from "../../AbstractElements";
import {
  Container,
  Row,
  Input,
  Table,
  CardHeader,
  CardFooter,
  Col,
  Card,
  InputGroup,
  Media,
} from "reactstrap";
import cloneDeep from "lodash/cloneDeep";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import "../../assets/scss/index.less";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { FormGroup, Label } from "reactstrap";

import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import * as mergedQueries from "../../graphql/mergedQueries";
import { toast } from "react-toastify";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ScrollBar from "react-perfect-scrollbar";
import AWS from "aws-sdk";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
  REGION,
  USERPOOLID,
  COMPANY_FOLDER,
  S3_BUCKET,
  limit,
} from "../../Config/Config";
import { SiteContext, SiteDetailsContext, aocontext } from "../../App";
import { Typeahead } from "react-bootstrap-typeahead";
import { nanoid } from "nanoid";
import SPCompany from "../../Data/SPCompanyData/index";
import SiteData from "../../Data/Sites/index";
import { generateClient } from "aws-amplify/api";

const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});
const base64 = require("base-64");

const ServiceProviderDetails = () => {
  AWS.config.update({
    accessKeyId: process.env.REACT_APP_ACCESSKEYID,
    secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    e,
    ...form
  } = useForm();

  const [listofServiceProviders, setlistofServiceProviders] = useState([]);
  const [spcompanyname, setspcompanyname] = useState([]);
  const [spCompany, setSpCompany] = useState(SPCompany.getSPCompany());
  const countPerPage = 10;
  const [value, setValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [collection, setCollection] = useState([]);
  const [sites, setsites] = useState([]);
  const [sitesSelected, setsitesSelected] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [spglobal, setspglobal] = useState([]);
  const [siteError, setSiteError] = useState(false);
  const [siteListVersion, setSiteListVersion] = useState(false);
  const { selectedAssetOwnerGlobal, handleAssetOwner } = useContext(aocontext);
  const [customdata, setcustomdata] = useState([]);

  const permissionsList = [
    "Create Tasks",
    "Assign Tasks",
    "View Tasks",
    "Export Tasks",
    "Create Certificates",
    "View Certificates",
    "Download Reports",
    "View Reports",
  ];

  const COGNITO_CLIENT = new AWS.CognitoIdentityServiceProvider({
    apiVersion: "2022-10-03",
    region: "ap-southeast-2",
  });

  const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (item) => {
    setShow(true);
    setItemforPermission(item);
    fnPermissionPopup(item);
  };

  const [showAddCompany, setShowAddCompany] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [newCompanyId, setNewCompanyId] = useState("");

  const [showInvite, setShowInvite] = useState(false);
  const handleShowInvite = () => setShowInvite(true);
  const handleCloseInvite = () => {
    reset();
    setShowAddCompany(false);
    setShowInvite(false);
  };

  const [itemforPermission, setItemforPermission] = useState([]);
  const [username, setusername] = useState([]);
  const [usercomp, setusercomp] = useState([]);
  const [spDB, setSpDB] = useState([]);
  const [siteuserexist, setsiteuserexist] = useState(SiteData.getSiteData());

  const LoginUserDetails = JSON.parse(localStorage.getItem("userDetails"));
  const LoggedInUserId = LoginUserDetails.id;

  const [filteredData, setFilteredData] = useState([]);

  const fnPermissionPopup = (item) => {
    if (item.permission) {
      setPermissions(JSON.parse(item.permission));
    } else {
      setPermissions([]);
    }
  };

  const LoginUserGroup = localStorage.getItem("groups");
  var status = LoginUserGroup === "admin" ? "Active" : "Inactive";

  const handleEdit = useCallback(
    (row) => navigate(`/addedit/${row.id}`),
    [navigate],
  );
  const handleView = useCallback(
    (row) => navigate(`/addedit/${row.id}/view`),
    [navigate],
  );

  const { selectedSiteGlobal, handleSiteChange } = useContext(SiteContext);

  const editPermissions = async () => {
    try {
      let otherPerm = ["View Logbooks", "View Service Providers"];
      let permSet = new Set(permissions);
      otherPerm.forEach((permission) => permSet.add(permission));
      let perm = Array.from(permSet);

      client
        .graphql({
          query: mutations.updateUserDetails,
          variables: {
            input: {
              id: itemforPermission.id,
              permissions: JSON.stringify(perm),
            },
          },
        })
        .catch((error) => console.error(error));

      await client
        .graphql({
          query: mutations.updateSPUserDetails,
          variables: {
            input: {
              id: itemforPermission.id,
              permission: JSON.stringify(perm),
            },
          },
        })
        .then(() => {
          toast.success(" Updated successfully.", {
            position: toast.POSITION.TOP_CENTER,
          });
          window.location = `/addedit/${itemforPermission.id}/view`;
        })
        .catch((error) => {
          console.error(error);
          toast.error(" Error while Updating ", {
            position: toast.POSITION.TOP_CENTER,
          });
        });
    } catch (error) {
      console.error(error);
    }
  };

  async function fetchUser() {
    try {
      let nextToken = "";
      let assets = [];
      const result = await client.graphql({
        query: queries.listUserDetails,
        variables: { limit: 2000000 },
        authMode: "API_KEY",
      });

      if (result.data.listUserDetails.items.length > 0) {
        let assetDatas = result.data.listUserDetails.items;
        nextToken = result.data.listUserDetails.nextToken;
        assets.push(assetDatas);

        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.listUserDetails,
            variables: { limit: 2000000, nextToken: nextToken },
            authMode: "API_KEY",
          });
          if (results.data.listUserDetails.items.length > 0) {
            nextToken = results.data.listUserDetails.nextToken;
            assets.push(results.data.listUserDetails.items);
          } else {
            nextToken = null;
          }
        }
        if (assets.length > 0) {
          setusername(assets.flat(1));
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchspusercompany() {
    try {
      let nextToken = "";
      let assets = [];
      const result = await client.graphql({
        query: queries.listSPCompanyDetails,
        variables: { limit: 2000000 },
        authMode: "API_KEY",
      });

      if (result.data.listSPCompanyDetails.items.length > 0) {
        let assetDatas = result.data.listSPCompanyDetails.items;
        nextToken = result.data.listSPCompanyDetails.nextToken;
        assets.push(assetDatas);

        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.listSPCompanyDetails,
            variables: { limit: 2000000, nextToken: nextToken },
            authMode: "API_KEY",
          });
          if (results.data.listSPCompanyDetails.items.length > 0) {
            nextToken = results.data.listSPCompanyDetails.nextToken;
            assets.push(results.data.listSPCompanyDetails.items);
          } else {
            nextToken = null;
          }
        }
        if (assets.length > 0) {
          setusercomp(assets.flat(1));
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  }

  function getUsername(spid) {
    const name = username.find((item) => item.id === spid);
    return name ? name.username : "";
  }

  function getCompnayLicence(spid) {
    const name = username.find((item) => item.id === spid);
    if (name) {
      const assetOwnerId = name.companyDetailsId;
      const assetOwnerNew = usercomp.find((item) => item.id === assetOwnerId);
      if (assetOwnerNew) {
        return assetOwnerNew.companyLicense;
      }
    }
    return "";
  }

  function getUsercompnay(spid) {
    if (spid) {
      const assetOwnerNew = usercomp.find((item) => item.id === spid);
      if (assetOwnerNew) {
        return assetOwnerNew.companyName;
      }
    }
    return "";
  }

  async function fetchSp() {
    try {
      const result = await client.graphql({
        query: queries.listSPUserDetails,
        variables: {
          filter: { userGroup: { eq: "electrician" } },
          limit: 10000,
        },
        authMode: "API_KEY",
      });

      const sites = result.data.listSPUserDetails.items;
      if (sites.length > 0) {
        let nextToken = result.data.listSPUserDetails.nextToken;
        let spUsers = [sites];

        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.listSPUserDetails,
            variables: {
              nextToken: nextToken,
              filter: { userGroup: { eq: "electrician" } },
              limit: 10000,
            },
            authMode: "API_KEY",
          });
          if (results.data.listSPUserDetails.items.length > 0) {
            nextToken = results.data.listSPUserDetails.nextToken;
            spUsers.push(results.data.listSPUserDetails.items);
          } else {
            nextToken = null;
          }
        }
        if (spUsers.length > 0) {
          setSpDB(sites);
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  }

  async function fetchSitesForUserExist() {
    try {
      let nextToken = "";
      let assets = [];
      const result = await client.graphql({
        query: queries.listSiteDetails,
        variables: { limit: 2000000, filter: { status: { eq: "Active" } } },
        authMode: "API_KEY",
      });

      if (result.data.listSiteDetails.items.length > 0) {
        let assetDatas = result.data.listSiteDetails.items;
        nextToken = result.data.listSiteDetails.nextToken;
        assets.push(assetDatas);

        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.listSiteDetails,
            variables: {
              limit: 2000000,
              filter: { status: { eq: "Active" } },
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          if (results.data.listSiteDetails.items.length > 0) {
            nextToken = results.data.listSiteDetails.nextToken;
            assets.push(results.data.listSiteDetails.items);
          } else {
            nextToken = null;
          }
        }
        if (assets.length > 0) {
          setsiteuserexist(assets.flat(1));
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const onSubmit = useCallback(async (formData, e) => {
    setLoading(true);
    let dupLicence = "";
    if (formData.Licencenumb !== undefined) {
      dupLicence = spcompanyname.filter((company) => {
        if (company.companyLicense != null) {
          return (
            company.companyLicense.toLowerCase() ===
            formData.Licencenumb.toLowerCase()
          );
        }
        return false;
      });
    }

    let dupLicencesp = "";
    if (formData.licence !== undefined) {
      const inputLicence = formData.licence?.trim().toLowerCase();
      dupLicencesp = spDB.filter((sp) => {
        if (sp.license != null) {
          const dbLicence = sp.license?.trim().toLowerCase();
          return dbLicence === inputLicence;
        }
        return false;
      });
    }

    if (dupLicencesp.length === 0) {
      if (dupLicence.length === 0) {
        let otherPerm = ["View Logbooks", "View Service Providers"];
        let perm = permissions.length > 0 ? permissions.concat(otherPerm) : [];

        if (sitesSelected.length > 0) {
          setSiteError(false);
          try {
            const result = await client.graphql({
              query: queries.userDetailsByEmail,
              variables: {
                email: formData.email,
                filter: { username: { ne: "admin" } },
              },
              authMode: "API_KEY",
            });

            const emailcompfilter =
              result.data.userDetailsByEmail.items.length > 0 &&
              result.data.userDetailsByEmail.items.filter(
                (item) => item.companyDetailsId === formData.company,
              );

            if (emailcompfilter.length > 0) {
              const filteredUsers = await client.graphql({
                query: queries.getSPUserDetails,
                variables: { id: emailcompfilter[0].id },
                authMode: "API_KEY",
              });

              if (filteredUsers !== null) {
                if (
                  filteredUsers.data.getSPUserDetails.userGroup !== "site_user"
                ) {
                  let successCount = 0;
                  let siteIds = [];
                  let siteIdsmatch = [];
                  let errorCount = 0;

                  if (showAddCompany) {
                    let userSub = "";
                    let userEmail = "";
                    let userName = "";
                    try {
                      let un = formData.email.split("@");
                      userName = un[0].toLowerCase() + "elect";
                      let nname = userName + nanoid(5);
                      userName = nname.toLowerCase();
                      const cognitoParams = {
                        UserPoolId: USERPOOLID,
                        Username: userName.replace(/\s/g, ""),
                        UserAttributes: [
                          { Name: "email", Value: formData.email },
                        ],
                        DesiredDeliveryMediums: ["EMAIL"],
                        TemporaryPassword: userName + "Z@123456789",
                        ForceAliasCreation: false,
                      };

                      let response =
                        await COGNITO_CLIENT.adminCreateUser(
                          cognitoParams,
                        ).promise();
                      const usersDetails = response.User.Attributes;
                      usersDetails.forEach((item) => {
                        if (item.Name === "sub") userSub = item.Value;
                        if (item.Name === "email") userEmail = item.Value;
                      });

                      const emailVerificationParams = {
                        UserPoolId: USERPOOLID,
                        Username: userName.replace(/\s/g, ""),
                        UserAttributes: [
                          { Name: "email_verified", Value: "true" },
                        ],
                      };

                      await COGNITO_CLIENT.adminUpdateUserAttributes(
                        emailVerificationParams,
                      ).promise();

                      var params = {
                        GroupName: "electrician",
                        UserPoolId: USERPOOLID,
                        Username: userName.replace(/\s/g, ""),
                      };
                      await COGNITO_CLIENT.adminAddUserToGroup(
                        params,
                      ).promise();

                      try {
                        await client
                          .graphql({
                            query: mutations.createSPCompanyDetails,
                            variables: {
                              input: {
                                companyName: formData.companyname,
                                companyBN: formData.businessNumber,
                                status: "Inactive",
                                email: formData.companyEmail,
                              },
                            },
                            authMode: "API_KEY",
                          })
                          .then(async (result) => {
                            setShowAddCompany(!showAddCompany);
                            const addedsite = await client.graphql({
                              query: queries.getSPCompanyDetails,
                              variables: {
                                id: result.data.createSPCompanyDetails.id,
                              },
                              authMode: "API_KEY",
                            });

                            if (addedsite.data.getSPCompanyDetails !== null) {
                              if (localStorage.getItem("spCompany") !== null) {
                                let activeDB = JSON.parse(
                                  base64.decode(
                                    localStorage.getItem("spCompany"),
                                  ),
                                );
                                activeDB.push(
                                  addedsite.data.getSPCompanyDetails,
                                );
                                localStorage.setItem(
                                  "spCompany",
                                  base64.encode(JSON.stringify(activeDB)),
                                );
                              }
                            }

                            fetchSpCompanyname();
                            toast.success("Successfully added new Company", {
                              position: toast.POSITION.TOP_CENTER,
                            });

                            await client.graphql({
                              query: mutations.createUserDetails,
                              variables: {
                                input: {
                                  id: userSub,
                                  username: userName.replace(/\s/g, ""),
                                  email: userEmail,
                                  assetOwnerId:
                                    LoginUserGroup === "site_user" ||
                                    LoginUserGroup === "electrician"
                                      ? LoginUserDetails.assetOwnerId
                                      : LoginUserDetails.id,
                                  companyDetailsId: result.data
                                    .createSPCompanyDetails.id
                                    ? result.data.createSPCompanyDetails.id
                                    : formData.company,
                                  status: "Active",
                                  permissions: showAddCompany
                                    ? JSON.stringify(perm)
                                    : [],
                                },
                              },
                              authMode: "API_KEY",
                            });

                            await client
                              .graphql({
                                query: mutations.createSPUserDetails,
                                variables: {
                                  input: {
                                    id: userSub,
                                    fname: formData.firstName,
                                    lname: formData.lastName,
                                    email: formData.email,
                                    userGroup: "electrician",
                                    invitedBy: LoggedInUserId,
                                    status: status,
                                    license: formData.licence,
                                    SPGroup: showAddCompany ? "admin" : "",
                                    permission: showAddCompany
                                      ? JSON.stringify(perm)
                                      : [],
                                    spcompanydetailsID: result.data
                                      .createSPCompanyDetails.id
                                      ? result.data.createSPCompanyDetails.id
                                      : formData.company,
                                  },
                                },
                                authMode: "API_KEY",
                              })
                              .then(async () => {
                                const addedsite = await client.graphql({
                                  query: queries.getSPUserDetails,
                                  variables: { id: userSub },
                                  authMode: "API_KEY",
                                });

                                const newUser =
                                  addedsite?.data?.getSPUserDetails;
                                if (!newUser) return;

                                let electricianList = [];
                                if (localStorage.getItem("electricianlist")) {
                                  try {
                                    electricianList = JSON.parse(
                                      base64.decode(
                                        localStorage.getItem("electricianlist"),
                                      ),
                                    );
                                  } catch (e) {
                                    electricianList = [];
                                  }
                                }

                                electricianList.push(newUser);
                                localStorage.setItem(
                                  "electricianlist",
                                  base64.encode(
                                    JSON.stringify(electricianList),
                                  ),
                                );

                                e.target.reset();
                                setShowInvite(false);
                                fetchspusercompany();
                                listSPDetails("All Time");
                                fetchSp();
                                reset();
                                fetchUser();

                                await Promise.all(
                                  sitesSelected?.map(async (item) => {
                                    await client.graphql({
                                      query: mutations.updateSPUserDetails,
                                      variables: {
                                        input: {
                                          sitedetailsID: item.id,
                                          id: userSub,
                                        },
                                      },
                                      authMode: "API_KEY",
                                    });

                                    await client
                                      .graphql({
                                        query: mutations.createLinkUsersAndSite,
                                        variables: {
                                          input: {
                                            sitedetailsID: item.id,
                                            userdetailsID: userSub,
                                            status: "Active",
                                          },
                                        },
                                        authMode: "API_KEY",
                                      })
                                      .catch((error) => {
                                        console.log(error);
                                        toast.error(" Error while Creating ", {
                                          position: toast.POSITION.TOP_CENTER,
                                        });
                                      });
                                  }),
                                );

                                setSiteListVersion(true);
                                listSPDetails("All Time");
                                setLoading(false);
                                reset();
                                setsitesSelected([]);
                                toast.success("Created successfully.", {
                                  position: toast.POSITION.TOP_CENTER,
                                });
                              })
                              .catch((errors) => {
                                toast.error(errors.message || String(errors), {
                                  position: toast.POSITION.TOP_CENTER,
                                });
                              });
                          })
                          .catch((error) => {
                            toast.error(
                              "Error while adding new Company, try again",
                              { position: toast.POSITION.TOP_CENTER },
                            );
                            console.error(error);
                          });
                      } catch (error) {
                        console.error(error);
                      }
                    } catch (err) {
                      console.error(err);
                      toast.error(err.message, {
                        position: toast.POSITION.TOP_CENTER,
                      });
                    }
                  } else {
                    await client
                      .graphql({
                        query: queries.linkUsersAndSitesByUserdetailsID,
                        variables: {
                          userdetailsID: filteredUsers.data.getSPUserDetails.id,
                        },
                        authMode: "API_KEY",
                      })
                      .then(async (result) => {
                        const filterUser =
                          result.data.linkUsersAndSitesByUserdetailsID.items;
                        const sitedetailsIDs = filterUser.map(
                          (item) => item.sitedetailsID,
                        );
                        const FilterSites = siteuserexist.filter((item) =>
                          sitedetailsIDs.includes(item.id),
                        );

                        await Promise.all(
                          sitesSelected?.map(async (item) => {
                            const matchingSite = FilterSites.find(
                              (site) => site.id === item.id,
                            );

                            if (matchingSite) {
                              successCount++;
                              errorCount++;
                              siteIdsmatch.push(item.id);
                            } else {
                              await client
                                .graphql({
                                  query: mutations.createLinkUsersAndSite,
                                  variables: {
                                    input: {
                                      sitedetailsID: item.id,
                                      userdetailsID:
                                        filteredUsers.data.getSPUserDetails.id,
                                      status: "Active",
                                    },
                                  },
                                  authMode: "API_KEY",
                                })
                                .then(() => {
                                  successCount++;
                                  siteIds.push(item.id);

                                  if (sitesSelected.length === successCount) {
                                    const matchingSite = siteuserexist.filter(
                                      (item) => siteIds.includes(item.id),
                                    );
                                    const siteNames = matchingSite.map(
                                      (site) =>
                                        `${site.siteName} (${site.unitNumber})`,
                                    );
                                    toast.success(
                                      `Created Successfully for sites: ${siteNames.join(", ")}`,
                                      { position: toast.POSITION.TOP_CENTER },
                                    );
                                  }
                                })
                                .catch((error) => {
                                  console.error(error);
                                  toast.error("Error while Creating ", {
                                    position: toast.POSITION.TOP_CENTER,
                                  });
                                });

                              setLoading(false);
                              e.target.reset();
                              setShowInvite(false);
                              fetchspusercompany();
                              setSiteListVersion(true);
                              reset();
                              listSPDetails("All Time");
                              fetchUser();
                              setsitesSelected([]);
                              await fetchSp();
                            }
                          }),
                        );

                        if (errorCount > 0) {
                          const matchingSite = siteuserexist.filter((item) =>
                            siteIdsmatch.includes(item.id),
                          );
                          const siteNames = matchingSite.map(
                            (site) => `${site.siteName} (${site.unitNumber})`,
                          );
                          toast.success(
                            `User has already accepted the invitation for site:  ${siteNames.join(", ")}`,
                            { position: toast.POSITION.TOP_CENTER },
                          );
                          setLoading(false);
                        }
                      })
                      .catch((error) => console.error(error));
                  }
                } else {
                  let userSub = "";
                  let userEmail = "";
                  let userName = "";
                  try {
                    let un = formData.email.split("@");
                    userName = un[0].toLowerCase() + "elect";
                    await client
                      .graphql({
                        query: queries.listUserDetails,
                        variables: {
                          limit: 10000,
                          filter: {
                            username: { eq: userName.replace(/\s/g, "") },
                            email: { eq: formData.email },
                          },
                        },
                        authMode: "API_KEY",
                      })
                      .then(async (userD) => {
                        if (userD.data.listUserDetails.items.length > 0) {
                          toast.success(
                            `User has already accepted the invitation for all selected site/s`,
                            { position: toast.POSITION.TOP_CENTER },
                          );
                          setLoading(false);
                        } else {
                          let nname = userName + nanoid(5);
                          userName = nname.toLowerCase();
                          const cognitoParams = {
                            UserPoolId: USERPOOLID,
                            Username: userName.replace(/\s/g, ""),
                            UserAttributes: [
                              { Name: "email", Value: formData.email },
                            ],
                            DesiredDeliveryMediums: ["EMAIL"],
                            TemporaryPassword: userName + "Z@123456789",
                            ForceAliasCreation: false,
                          };

                          let response =
                            await COGNITO_CLIENT.adminCreateUser(
                              cognitoParams,
                            ).promise();
                          const usersDetails = response.User.Attributes;
                          usersDetails.forEach((item) => {
                            if (item.Name === "sub") userSub = item.Value;
                            if (item.Name === "email") userEmail = item.Value;
                          });

                          const emailVerificationParams = {
                            UserPoolId: USERPOOLID,
                            Username: userName.replace(/\s/g, ""),
                            UserAttributes: [
                              { Name: "email_verified", Value: "true" },
                            ],
                          };

                          await COGNITO_CLIENT.adminUpdateUserAttributes(
                            emailVerificationParams,
                          ).promise();

                          if (showAddCompany) {
                            try {
                              await client
                                .graphql({
                                  query: mutations.createSPCompanyDetails,
                                  variables: {
                                    input: {
                                      companyName: formData.companyname,
                                      companyBN: formData.businessNumber,
                                      status: "Inactive",
                                      email: formData.companyEmail,
                                    },
                                  },
                                  authMode: "API_KEY",
                                })
                                .then(async (result) => {
                                  setShowAddCompany(!showAddCompany);
                                  const addedsite = await client.graphql({
                                    query: queries.getSPCompanyDetails,
                                    variables: {
                                      id: result.data.createSPCompanyDetails.id,
                                    },
                                    authMode: "API_KEY",
                                  });
                                  if (
                                    addedsite.data.getSPCompanyDetails !== null
                                  ) {
                                    if (
                                      localStorage.getItem("spCompany") !== null
                                    ) {
                                      let activeDB = JSON.parse(
                                        base64.decode(
                                          localStorage.getItem("spCompany"),
                                        ),
                                      );
                                      activeDB.push(
                                        addedsite.data.getSPCompanyDetails,
                                      );
                                      localStorage.setItem(
                                        "spCompany",
                                        base64.encode(JSON.stringify(activeDB)),
                                      );
                                    }
                                  }
                                  fetchSpCompanyname();
                                  toast.success(
                                    "Successfully added new Company",
                                    { position: toast.POSITION.TOP_CENTER },
                                  );

                                  client.graphql({
                                    query: mutations.createUserDetails,
                                    variables: {
                                      input: {
                                        id: userSub,
                                        username: userName.replace(/\s/g, ""),
                                        email: userEmail,
                                        assetOwnerId:
                                          LoginUserGroup === "site_user" ||
                                          LoginUserGroup === "electrician"
                                            ? LoginUserDetails.assetOwnerId
                                            : LoginUserDetails.id,
                                        companyDetailsId:
                                          result.data.createSPCompanyDetails.id,
                                        status: "Active",
                                        permissions: JSON.stringify(perm),
                                      },
                                    },
                                    authMode: "API_KEY",
                                  });
                                  setNewCompanyId(
                                    result.data.createSPCompanyDetails.id,
                                  );
                                })
                                .catch((error) => {
                                  toast.error(
                                    "Error while adding new Company, try again",
                                    { position: toast.POSITION.TOP_CENTER },
                                  );
                                  console.error(error);
                                });
                            } catch (error) {
                              console.error(error);
                            }
                          } else {
                            client.graphql({
                              query: mutations.createUserDetails,
                              variables: {
                                input: {
                                  id: userSub,
                                  username: userName.replace(/\s/g, ""),
                                  email: userEmail,
                                  assetOwnerId:
                                    LoginUserGroup === "site_user" ||
                                    LoginUserGroup === "electrician"
                                      ? LoginUserDetails.assetOwnerId
                                      : LoginUserDetails.id,
                                  companyDetailsId: formData.company,
                                  status: "Active",
                                },
                              },
                              authMode: "API_KEY",
                            });
                          }

                          var params = {
                            GroupName: "electrician",
                            UserPoolId: USERPOOLID,
                            Username: userName.replace(/\s/g, ""),
                          };
                          await COGNITO_CLIENT.adminAddUserToGroup(
                            params,
                          ).promise();

                          const compsp = usercomp.filter(
                            (item) => item.id === formData.company,
                          );
                          await client.graphql({
                            query: mutations.createLinkAOAPCompany,
                            variables: {
                              input: {
                                companyName: compsp[0].companyName,
                                companyBN: compsp[0].companyBN,
                                companyAddress: compsp[0].companyAddress,
                                companyLicense: compsp[0].companyLicense,
                                logo: compsp[0].logo,
                                status: "Active",
                                email: compsp[0].email,
                                phone: compsp[0].phone,
                                spaoId: userSub,
                                spcomapnyId: formData.company,
                              },
                            },
                            authMode: "API_KEY",
                          });

                          const linkao = await client.graphql({
                            query: queries.linkAOAPCompaniesBySpaoId,
                            authMode: "API_KEY",
                            variables: {
                              spaoId:
                                LoginUserGroup === "site_user"
                                  ? LoginUserDetails.assetOwnerId
                                  : LoginUserDetails.id,
                              filter: { spcomapnyId: { eq: formData.company } },
                            },
                          });

                          if (
                            linkao.data.linkAOAPCompaniesBySpaoId.items
                              .length === 0
                          ) {
                            await client.graphql({
                              query: mutations.createLinkAOAPCompany,
                              variables: {
                                input: {
                                  companyName: compsp[0].companyName,
                                  companyBN: compsp[0].companyBN,
                                  companyAddress: compsp[0].companyAddress,
                                  companyLicense: compsp[0].companyLicense,
                                  logo: compsp[0].logo,
                                  status: "Active",
                                  email: compsp[0].email,
                                  phone: compsp[0].phone,
                                  spaoId:
                                    LoginUserGroup === "site_user"
                                      ? LoginUserDetails.assetOwnerId
                                      : LoginUserDetails.id,
                                  spcomapnyId: formData.company,
                                },
                              },
                              authMode: "API_KEY",
                            });
                          }

                          if (LoginUserGroup === "electrician") {
                            const linkspsao = await client.graphql({
                              query: queries.linkAOAPCompaniesBySpaoId,
                              authMode: "API_KEY",
                              variables: {
                                spaoId: LoginUserDetails.assetOwnerId,
                                filter: {
                                  spcomapnyId: { eq: formData.company },
                                },
                              },
                            });

                            if (
                              linkspsao.data.linkAOAPCompaniesBySpaoId.items
                                .length === 0
                            ) {
                              await client.graphql({
                                query: mutations.createLinkAOAPCompany,
                                variables: {
                                  input: {
                                    companyName: compsp[0].companyName,
                                    companyBN: compsp[0].companyBN,
                                    companyAddress: compsp[0].companyAddress,
                                    companyLicense: compsp[0].companyLicense,
                                    logo: compsp[0].logo,
                                    status: "Active",
                                    email: compsp[0].email,
                                    phone: compsp[0].phone,
                                    spaoId: LoginUserDetails.assetOwnerId,
                                    spcomapnyId: formData.company,
                                  },
                                },
                                authMode: "API_KEY",
                              });
                            }
                          }

                          client
                            .graphql({
                              query: mutations.createSPUserDetails,
                              variables: {
                                input: {
                                  id: userSub,
                                  fname: formData.firstName,
                                  lname: formData.lastName,
                                  email: formData.email,
                                  userGroup: "electrician",
                                  invitedBy: LoggedInUserId,
                                  status: status,
                                  license: formData.licence,
                                  SPGroup: showAddCompany ? "admin" : "",
                                  permission: showAddCompany
                                    ? JSON.stringify(perm)
                                    : [],
                                  spcompanydetailsID: formData.company,
                                },
                              },
                              authMode: "API_KEY",
                            })
                            .then(async () => {
                              const addedsite = await client.graphql({
                                query: queries.getSPUserDetails,
                                variables: { id: userSub },
                                authMode: "API_KEY",
                              });
                              const newUser = addedsite?.data?.getSPUserDetails;
                              if (!newUser) return;

                              let electricianList = [];
                              if (localStorage.getItem("electricianlist")) {
                                try {
                                  electricianList = JSON.parse(
                                    base64.decode(
                                      localStorage.getItem("electricianlist"),
                                    ),
                                  );
                                } catch (e) {
                                  electricianList = [];
                                }
                              }
                              electricianList.push(newUser);
                              localStorage.setItem(
                                "electricianlist",
                                base64.encode(JSON.stringify(electricianList)),
                              );

                              e.target.reset();
                              setShowInvite(false);
                              fetchspusercompany();
                              fetchSp();
                              reset();
                              fetchUser();
                              listSPDetails("All Time");

                              await Promise.all(
                                sitesSelected?.map(async (item) => {
                                  client.graphql({
                                    query: mutations.updateSPUserDetails,
                                    variables: {
                                      input: {
                                        sitedetailsID: item.id,
                                        id: userSub,
                                      },
                                    },
                                    authMode: "API_KEY",
                                  });
                                  await client
                                    .graphql({
                                      query: mutations.createLinkUsersAndSite,
                                      variables: {
                                        input: {
                                          sitedetailsID: item.id,
                                          userdetailsID: userSub,
                                          status: "Active",
                                        },
                                      },
                                      authMode: "API_KEY",
                                    })
                                    .catch((error) => {
                                      console.error(error);
                                      toast.error(" Error while Creating ", {
                                        position: toast.POSITION.TOP_CENTER,
                                      });
                                    });
                                }),
                              );

                              setSiteListVersion(true);
                              listSPDetails("All Time");
                              reset();
                              setsitesSelected([]);
                              setLoading(false);
                              toast.success(" Created successfully.", {
                                position: toast.POSITION.TOP_CENTER,
                              });
                            })
                            .catch((errors) => {
                              toast.error(errors.message || String(errors), {
                                position: toast.POSITION.TOP_CENTER,
                              });
                            });
                        }
                      });
                  } catch (err) {
                    console.error(err);
                    toast.error(err.message, {
                      position: toast.POSITION.TOP_CENTER,
                    });
                  }
                }
              }
            } else {
              let userSub = "";
              let userEmail = "";
              let userName = "";
              try {
                let un = formData.email.split("@");
                userName = un[0].toLowerCase() + "elect";
                await client
                  .graphql({
                    query: queries.listUserDetails,
                    variables: {
                      limit: 10000,
                      filter: {
                        username: { eq: userName.replace(/\s/g, "") },
                        email: { eq: formData.email },
                      },
                    },
                    authMode: "API_KEY",
                  })
                  .then(async (userD) => {
                    if (userD.data.listUserDetails.items.length > 0) {
                      toast.success(
                        `User has already accepted the invitation for all selected site/s`,
                        { position: toast.POSITION.TOP_CENTER },
                      );
                    } else {
                      let nname = userName + nanoid(5);
                      userName = nname.toLowerCase();
                      const cognitoParams = {
                        UserPoolId: USERPOOLID,
                        Username: userName.replace(/\s/g, ""),
                        UserAttributes: [
                          { Name: "email", Value: formData.email },
                        ],
                        DesiredDeliveryMediums: ["EMAIL"],
                        TemporaryPassword: userName + "Z@123456789",
                        ForceAliasCreation: false,
                      };

                      let response =
                        await COGNITO_CLIENT.adminCreateUser(
                          cognitoParams,
                        ).promise();
                      const usersDetails = response.User.Attributes;
                      usersDetails.forEach((item) => {
                        if (item.Name === "sub") userSub = item.Value;
                        if (item.Name === "email") userEmail = item.Value;
                      });

                      const emailVerificationParams = {
                        UserPoolId: USERPOOLID,
                        Username: userName.replace(/\s/g, ""),
                        UserAttributes: [
                          { Name: "email_verified", Value: "true" },
                        ],
                      };
                      await COGNITO_CLIENT.adminUpdateUserAttributes(
                        emailVerificationParams,
                      ).promise();

                      if (showAddCompany) {
                        try {
                          await client
                            .graphql({
                              query: mutations.createSPCompanyDetails,
                              variables: {
                                input: {
                                  companyName: formData.companyname,
                                  companyBN: formData.businessNumber,
                                  status: "Inactive",
                                  email: formData.companyEmail,
                                },
                              },
                              authMode: "API_KEY",
                            })
                            .then(async (result) => {
                              setShowAddCompany(!showAddCompany);
                              const addedsite = await client.graphql({
                                query: queries.getSPCompanyDetails,
                                variables: {
                                  id: result.data.createSPCompanyDetails.id,
                                },
                                authMode: "API_KEY",
                              });
                              if (addedsite.data.getSPCompanyDetails !== null) {
                                if (
                                  localStorage.getItem("spCompany") !== null
                                ) {
                                  let activeDB = JSON.parse(
                                    base64.decode(
                                      localStorage.getItem("spCompany"),
                                    ),
                                  );
                                  activeDB.push(
                                    addedsite.data.getSPCompanyDetails,
                                  );
                                  localStorage.setItem(
                                    "spCompany",
                                    base64.encode(JSON.stringify(activeDB)),
                                  );
                                }
                              }
                              fetchSpCompanyname();
                              toast.success("Successfully added new Company", {
                                position: toast.POSITION.TOP_CENTER,
                              });

                              client.graphql({
                                query: mutations.createUserDetails,
                                variables: {
                                  input: {
                                    id: userSub,
                                    username: userName.replace(/\s/g, ""),
                                    email: userEmail,
                                    assetOwnerId:
                                      LoginUserGroup === "site_user" ||
                                      LoginUserGroup === "electrician"
                                        ? LoginUserDetails.assetOwnerId
                                        : LoginUserDetails.id,
                                    companyDetailsId:
                                      result.data.createSPCompanyDetails.id,
                                    status: "Active",
                                    permissions: JSON.stringify(perm),
                                  },
                                },
                                authMode: "API_KEY",
                              });
                              setNewCompanyId(
                                result.data.createSPCompanyDetails.id,
                              );

                              client
                                .graphql({
                                  query: mutations.createSPUserDetails,
                                  variables: {
                                    input: {
                                      id: userSub,
                                      fname: formData.firstName,
                                      lname: formData.lastName,
                                      email: formData.email,
                                      userGroup: "electrician",
                                      invitedBy: LoggedInUserId,
                                      status: status,
                                      license: formData.licence,
                                      SPGroup: showAddCompany ? "admin" : "",
                                      permission: showAddCompany
                                        ? JSON.stringify(perm)
                                        : [],
                                      spcompanydetailsID:
                                        result.data.createSPCompanyDetails.id,
                                    },
                                  },
                                  authMode: "API_KEY",
                                })
                                .then(async () => {
                                  const addedsite = await client.graphql({
                                    query: queries.getSPUserDetails,
                                    variables: { id: userSub },
                                    authMode: "API_KEY",
                                  });
                                  const newUser =
                                    addedsite?.data?.getSPUserDetails;
                                  if (!newUser) return;

                                  let electricianList = [];
                                  if (localStorage.getItem("electricianlist")) {
                                    try {
                                      electricianList = JSON.parse(
                                        base64.decode(
                                          localStorage.getItem(
                                            "electricianlist",
                                          ),
                                        ),
                                      );
                                    } catch (e) {
                                      electricianList = [];
                                    }
                                  }
                                  electricianList.push(newUser);
                                  localStorage.setItem(
                                    "electricianlist",
                                    base64.encode(
                                      JSON.stringify(electricianList),
                                    ),
                                  );

                                  e.target.reset();
                                  setShowInvite(false);
                                  fetchspusercompany();
                                  reset();
                                  fetchSp();
                                  fetchUser();
                                  listSPDetails("All Time");

                                  await Promise.all(
                                    sitesSelected?.map(async (item) => {
                                      client.graphql({
                                        query: mutations.updateSPUserDetails,
                                        variables: {
                                          input: {
                                            sitedetailsID: item.id,
                                            id: userSub,
                                          },
                                        },
                                        authMode: "API_KEY",
                                      });
                                      await client
                                        .graphql({
                                          query:
                                            mutations.createLinkUsersAndSite,
                                          variables: {
                                            input: {
                                              sitedetailsID: item.id,
                                              userdetailsID: userSub,
                                              status: "Active",
                                            },
                                          },
                                          authMode: "API_KEY",
                                        })
                                        .catch((error) => {
                                          console.error(error);
                                          toast.error(
                                            " Error while Creating ",
                                            {
                                              position:
                                                toast.POSITION.TOP_CENTER,
                                            },
                                          );
                                        });
                                    }),
                                  );
                                  setLoading(false);
                                  setSiteListVersion(true);
                                  listSPDetails("All Time");
                                  reset();
                                  setsitesSelected([]);
                                  toast.success(" Created successfully.", {
                                    position: toast.POSITION.TOP_CENTER,
                                  });
                                })
                                .catch((errors) => {
                                  toast.error(
                                    errors.message || String(errors),
                                    { position: toast.POSITION.TOP_CENTER },
                                  );
                                });
                            })
                            .catch((error) => {
                              toast.error(
                                "Error while adding new Company, try again",
                                { position: toast.POSITION.TOP_CENTER },
                              );
                              console.error(error);
                            });
                        } catch (error) {
                          console.error(error);
                        }
                      } else {
                        await client.graphql({
                          query: mutations.createUserDetails,
                          variables: {
                            input: {
                              id: userSub,
                              username: userName.replace(/\s/g, ""),
                              email: userEmail,
                              assetOwnerId:
                                LoginUserGroup === "site_user" ||
                                LoginUserGroup === "electrician"
                                  ? LoginUserDetails.assetOwnerId
                                  : LoginUserDetails.id,
                              companyDetailsId: formData.company,
                              status: "Active",
                            },
                          },
                          authMode: "API_KEY",
                        });

                        const compsp = usercomp.filter(
                          (item) => item.id === formData.company,
                        );
                        await client.graphql({
                          query: mutations.createLinkAOAPCompany,
                          variables: {
                            input: {
                              companyName: compsp[0].companyName,
                              companyBN: compsp[0].companyBN,
                              companyAddress: compsp[0].companyAddress,
                              companyLicense: compsp[0].companyLicense,
                              logo: compsp[0].logo,
                              status: "Active",
                              email: compsp[0].email,
                              phone: compsp[0].phone,
                              spaoId: userSub,
                              spcomapnyId: compsp[0].id,
                            },
                          },
                          authMode: "API_KEY",
                        });

                        const linkao = await client.graphql({
                          query: queries.linkAOAPCompaniesBySpaoId,
                          authMode: "API_KEY",
                          variables: {
                            spaoId:
                              LoginUserGroup === "site_user"
                                ? LoginUserDetails.assetOwnerId
                                : LoginUserDetails.id,
                            filter: { spcomapnyId: { eq: formData.company } },
                          },
                        });

                        if (
                          linkao.data.linkAOAPCompaniesBySpaoId.items.length ===
                          0
                        ) {
                          await client.graphql({
                            query: mutations.createLinkAOAPCompany,
                            variables: {
                              input: {
                                companyName: compsp[0].companyName,
                                companyBN: compsp[0].companyBN,
                                companyAddress: compsp[0].companyAddress,
                                companyLicense: compsp[0].companyLicense,
                                logo: compsp[0].logo,
                                status: "Active",
                                email: compsp[0].email,
                                phone: compsp[0].phone,
                                spaoId:
                                  LoginUserGroup === "site_user"
                                    ? LoginUserDetails.assetOwnerId
                                    : LoginUserDetails.id,
                                spcomapnyId: formData.company,
                              },
                            },
                            authMode: "API_KEY",
                          });
                        }

                        if (LoginUserGroup === "electrician") {
                          const linkspsao = await client.graphql({
                            query: queries.linkAOAPCompaniesBySpaoId,
                            authMode: "API_KEY",
                            variables: {
                              spaoId: LoginUserDetails.assetOwnerId,
                              filter: { spcomapnyId: { eq: formData.company } },
                            },
                          });
                          if (
                            linkspsao.data.linkAOAPCompaniesBySpaoId.items
                              .length === 0
                          ) {
                            await client.graphql({
                              query: mutations.createLinkAOAPCompany,
                              variables: {
                                input: {
                                  companyName: compsp[0].companyName,
                                  companyBN: compsp[0].companyBN,
                                  companyAddress: compsp[0].companyAddress,
                                  companyLicense: compsp[0].companyLicense,
                                  logo: compsp[0].logo,
                                  status: "Active",
                                  email: compsp[0].email,
                                  phone: compsp[0].phone,
                                  spaoId: LoginUserDetails.assetOwnerId,
                                  spcomapnyId: formData.company,
                                },
                              },
                              authMode: "API_KEY",
                            });
                          }
                        }

                        client
                          .graphql({
                            query: mutations.createSPUserDetails,
                            variables: {
                              input: {
                                id: userSub,
                                fname: formData.firstName,
                                lname: formData.lastName,
                                email: formData.email,
                                userGroup: "electrician",
                                invitedBy: LoggedInUserId,
                                status: status,
                                license: formData.licence,
                                SPGroup: showAddCompany ? "admin" : "",
                                permission: showAddCompany
                                  ? JSON.stringify(perm)
                                  : [],
                                spcompanydetailsID: formData.company,
                              },
                            },
                            authMode: "API_KEY",
                          })
                          .then(async () => {
                            const addedsite = await client.graphql({
                              query: queries.getSPUserDetails,
                              variables: { id: userSub },
                              authMode: "API_KEY",
                            });
                            const newUser = addedsite?.data?.getSPUserDetails;
                            if (!newUser) return;

                            let electricianList = [];
                            if (localStorage.getItem("electricianlist")) {
                              try {
                                electricianList = JSON.parse(
                                  base64.decode(
                                    localStorage.getItem("electricianlist"),
                                  ),
                                );
                              } catch (e) {
                                electricianList = [];
                              }
                            }
                            electricianList.push(newUser);
                            localStorage.setItem(
                              "electricianlist",
                              base64.encode(JSON.stringify(electricianList)),
                            );

                            e.target.reset();
                            setShowInvite(false);
                            fetchspusercompany();
                            reset();
                            fetchSp();
                            fetchUser();
                            listSPDetails("All Time");

                            await Promise.all(
                              sitesSelected?.map(async (item) => {
                                client.graphql({
                                  query: mutations.updateSPUserDetails,
                                  variables: {
                                    input: {
                                      sitedetailsID: item.id,
                                      id: userSub,
                                    },
                                  },
                                  authMode: "API_KEY",
                                });
                                await client
                                  .graphql({
                                    query: mutations.createLinkUsersAndSite,
                                    variables: {
                                      input: {
                                        sitedetailsID: item.id,
                                        userdetailsID: userSub,
                                        status: "Active",
                                      },
                                    },
                                    authMode: "API_KEY",
                                  })
                                  .catch((error) => {
                                    console.error(error);
                                    toast.error(" Error while Creating ", {
                                      position: toast.POSITION.TOP_CENTER,
                                    });
                                  });
                              }),
                            );

                            setSiteListVersion(true);
                            listSPDetails("All Time");
                            reset();
                            setsitesSelected([]);
                            setLoading(false);
                            toast.success(" Created successfully.", {
                              position: toast.POSITION.TOP_CENTER,
                            });
                          })
                          .catch((errors) => {
                            toast.error(errors.message || String(errors), {
                              position: toast.POSITION.TOP_CENTER,
                            });
                          });
                      }
                      var params = {
                        GroupName: "electrician",
                        UserPoolId: USERPOOLID,
                        Username: userName.replace(/\s/g, ""),
                      };
                      await COGNITO_CLIENT.adminAddUserToGroup(
                        params,
                      ).promise();
                    }
                  });
              } catch (err) {
                console.error(err);
                toast.error(err.message, {
                  position: toast.POSITION.TOP_CENTER,
                });
              }
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          setSiteError(true);
        }
      } else {
        setLoading(false);
        toast.error(
          "Duplicate Electrical Licence Number.Please Check Electrical Licence Number Entered.",
          { position: toast.POSITION.TOP_CENTER },
        );
      }
    } else {
      setLoading(false);
      toast.error(
        "Duplicate License Number.Please Check License Number Entered.",
        { position: toast.POSITION.TOP_CENTER },
      );
    }
  });

  async function fetchSpCompanyname() {
    try {
      let nextToken = "";
      let assets = [];
      const result = await client.graphql({
        query: queries.listSPCompanyDetails,
        variables: { limit: 2000000 },
        authMode: "API_KEY",
      });
      if (result.data.listSPCompanyDetails.items.length > 0) {
        let assetDatas = result.data.listSPCompanyDetails.items;
        nextToken = result.data.listSPCompanyDetails.nextToken;
        assets.push(assetDatas);
        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.listSPCompanyDetails,
            variables: { limit: 2000000, nextToken: nextToken },
            authMode: "API_KEY",
          });
          if (results.data.listSPCompanyDetails.items.length > 0) {
            nextToken = results.data.listSPCompanyDetails.nextToken;
            assets.push(results.data.listSPCompanyDetails.items);
          } else {
            nextToken = null;
          }
        }
        if (assets.length > 0) {
          setspcompanyname(assets.flat(1));
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  }

  useEffect(() => {
    const initializeData = async () => {
      setIsLoading(true);
      await Promise.all([
        fetchSpCompanyname(),
        fetchSp(),
        fetchSitesForUserExist(),
        fetchUser(),
        fetchspusercompany(),
      ]);

      if (
        localStorage.getItem("spCompany") === null &&
        spCompany.length === 0
      ) {
        LoginUserGroup === "site_owner"
          ? fetchSpcompany(LoginUserDetails.id)
          : LoginUserGroup === "site_user" || LoginUserGroup === "electrician"
            ? fetchSPCompanySU(LoginUserDetails.id)
            : fetchSPCompanySPAO(LoginUserDetails);
      } else {
        setSpCompany(
          JSON.parse(base64.decode(localStorage.getItem("spCompany"))),
        );
      }
    };

    initializeData();
  }, []);

  async function fetchSPCompanySU(userId) {
    try {
      const getLinkAOAPCompanyDetails = await client.graphql({
        query: queries.linkAOAPCompaniesBySpaoId,
        authMode: "API_KEY",
        variables: { spaoId: userId, limit: 10000 },
      });
      if (
        getLinkAOAPCompanyDetails.data.linkAOAPCompaniesBySpaoId.items.length >
        0
      ) {
        SPCompany.setSPCompany(
          getLinkAOAPCompanyDetails.data.linkAOAPCompaniesBySpaoId.items,
        );
        setSpCompany(
          getLinkAOAPCompanyDetails.data.linkAOAPCompaniesBySpaoId.items,
        );
        localStorage.setItem(
          "spCompany",
          base64.encode(
            JSON.stringify(
              getLinkAOAPCompanyDetails.data.linkAOAPCompaniesBySpaoId.items,
            ),
          ),
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  }

  async function fetchSPCompanySPAO(user) {
    try {
      const getSPComp = await client.graphql({
        query: queries.getSPCompanyDetails,
        authMode: "API_KEY",
        variables: { id: user.companyDetailsId },
      });
      if (getSPComp.data.getSPCompanyDetails !== null) {
        let spcomp = [getSPComp.data.getSPCompanyDetails];
        SPCompany.setSPCompany(spcomp);
        setSpCompany(spcomp);
        localStorage.setItem(
          "spCompany",
          base64.encode(JSON.stringify(spcomp)),
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  }

  async function fetchSpcompany(asetOwnerId) {
    try {
      const getLinkAOAPCompanyDetails = await client.graphql({
        query: queries.linkAOAPCompaniesBySpaoId,
        authMode: "API_KEY",
        variables: { spaoId: asetOwnerId, limit: 10000 },
      });
      if (
        getLinkAOAPCompanyDetails.data.linkAOAPCompaniesBySpaoId.items.length >
        0
      ) {
        SPCompany.setSPCompany(
          getLinkAOAPCompanyDetails.data.linkAOAPCompaniesBySpaoId.items,
        );
        setSpCompany(
          getLinkAOAPCompanyDetails.data.linkAOAPCompaniesBySpaoId.items,
        );
        localStorage.setItem(
          "spCompany",
          base64.encode(
            JSON.stringify(
              getLinkAOAPCompanyDetails.data.linkAOAPCompaniesBySpaoId.items,
            ),
          ),
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  }

  const ApproveStatus = (status) => {
    return status.toLowerCase() === "active"
      ? "switch-state bg-success"
      : "switch-state bg-danger";
  };

  // const handleChange = async (item) => {
  //   try {
  //     var statusSp;
  //     if (item.status.toLowerCase() === "active") {
  //       statusSp = "Inactive";
  //       toast.success("Deactivated successfully.", {
  //         position: toast.POSITION.TOP_CENTER,
  //       });
  //     } else {
  //       statusSp = "Active";
  //       toast.success("Activated successfully.", {
  //         position: toast.POSITION.TOP_CENTER,
  //       });
  //     }

  //     const result = await client.graphql({
  //       query: mutations.updateSPUserDetails,
  //       variables: { input: { id: item.id, status: statusSp } },
  //     });
  //     if (result) {
  //       listSPDetails("All Time");
  //     } else {
  //       toast.error("Error while Updating ", {
  //         position: toast.POSITION.TOP_CENTER,
  //       });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const handleChange = async (item) => {
    try {
      var statusSp;
      if (item.status.toLowerCase() === "active") {
        statusSp = "Inactive";
        toast.success("Deactivated successfully.", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        statusSp = "Active";
        toast.success("Activated successfully.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }

      const result = await client.graphql({
        query: mutations.updateSPUserDetails,
        variables: { input: { id: item.id, status: statusSp } },
      });

      if (result) {
        // 1. Immediately update local state arrays for instant UI reflection
        const updateStatusFunc = (list) =>
          list.map((sp) =>
            sp.id === item.id ? { ...sp, status: statusSp } : sp,
          );

        setlistofServiceProviders((prev) => updateStatusFunc(prev));
        setCollection((prev) => updateStatusFunc(prev));

        // 2. Update the cached electricianlist in localStorage if present
        if (localStorage.getItem("electricianlist") !== null) {
          try {
            let electdata = JSON.parse(
              base64.decode(localStorage.getItem("electricianlist")),
            );
            let updatedElectData = electdata.map((sp) =>
              sp.id === item.id ? { ...sp, status: statusSp } : sp,
            );
            localStorage.setItem(
              "electricianlist",
              base64.encode(JSON.stringify(updatedElectData)),
            );
          } catch (e) {
            console.error("Error updating localStorage electricianlist:", e);
          }
        }

        // 3. Refresh list details
        listSPDetails("All Time");
      } else {
        toast.error("Error while Updating ", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    listSPDetails("All Time");
  }, [selectedSiteGlobal, selectedAssetOwnerGlobal, spglobal]);

  useEffect(() => {
    if (siteListVersion === true) {
      listSPDetails("All Time");
      fetchUser();
      setSiteListVersion(false);
    }
  }, [siteListVersion]);

  async function fetchSites() {
    try {
      let nextToken = "";
      let assets = [];
      const result = await client.graphql({
        query: queries.listSiteDetails,
        variables: { limit: limit },
        authMode: "API_KEY",
      });
      if (result.data.listSiteDetails.items.length > 0) {
        let assetDatas = result.data.listSiteDetails.items;
        nextToken = result.data.listSiteDetails.nextToken;
        assets.push(assetDatas);
        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.listSiteDetails,
            variables: { limit: limit, nextToken: nextToken },
            authMode: "API_KEY",
          });
          if (results.data.listSiteDetails.items.length > 0) {
            nextToken = results.data.listSiteDetails.nextToken;
            assets.push(results.data.listSiteDetails.items);
          } else {
            nextToken = null;
          }
        }
        if (assets.length > 0) {
          setsites(assets.flat(1));
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (LoginUserGroup === "admin") {
      fetchSites();
    } else {
      if (localStorage.getItem("site") === null && sites.length === 0) {
        LoginUserGroup === "site_owner" || LoginUserGroup === "spao"
          ? fetchSiteDetailsAO()
          : LoginUserGroup === "site_user"
            ? fetchSiteDetailsSU()
            : fetchSiteDetailsSP(LoginUserDetails.id);
      } else {
        let activeSites = JSON.parse(
          base64.decode(localStorage.getItem("site")),
        );
        if (selectedSiteGlobal) {
          const filterdata = activeSites.filter(
            (item) => item.id === selectedSiteGlobal,
          );
          setsites(filterdata.filter((item) => item.status === "Active"));
        } else {
          setsites(activeSites.filter((item) => item.status === "Active"));
        }
      }
    }
  }, [selectedSiteGlobal]);

  async function fetchSiteDetailsSU() {
    try {
      const response = await client.graphql({
        query: mergedQueries.getSiteUsersFromLink,
        authMode: "API_KEY",
        variables: {
          assetownerID: LoginUserDetails.assetOwnerId,
          userdetailsID: LoginUserDetails.id,
        },
      });
      let nextToken = "";
      let sitess = [];
      if (response.data.siteDetailsByAssetownerID.items.length > 0) {
        let sites = response.data.siteDetailsByAssetownerID.items;
        nextToken = response.data.siteDetailsByAssetownerID.nextToken;
        for (let site of sites) {
          if (site.LinkUsersAndSites.items.length > 0) {
            sitess.push(site);
          }
        }
        while (nextToken !== null) {
          const results = await client.graphql({
            query: mergedQueries.getSiteUsersFromLink,
            variables: {
              nextToken: nextToken,
              assetownerID: LoginUserDetails.assetOwnerId,
              userdetailsID: LoginUserDetails.id,
            },
            authMode: "API_KEY",
          });
          nextToken = results.data.siteDetailsByAssetownerID.nextToken;
          sites = results.data.siteDetailsByAssetownerID.items;
          for (let site of sites) {
            if (site.LinkUsersAndSites.items.length > 0) {
              sitess.push(site);
            }
          }
        }
        if (sitess.length > 0) {
          const mergeSites = sitess.flat(1);
          if (selectedSiteGlobal) {
            const filterdata = mergeSites.filter(
              (item) => item.id === selectedSiteGlobal,
            );
            setsites(filterdata.filter((item) => item.status === "Active"));
          } else {
            setsites(mergeSites.filter((item) => item.status === "Active"));
          }
          SiteData.setSiteData(mergeSites);
          localStorage.setItem(
            "site",
            base64.encode(JSON.stringify(mergeSites)),
          );
        }
      }
    } catch (error) {
      console.error(error);
      setsites([]);
    }
  }

  async function fetchSiteDetailsSP(assetOwnerId) {
    try {
      let nextToken = "";
      let sites = [];
      const result = await client.graphql({
        query: queries.linkUsersAndSitesByUserdetailsID,
        authMode: "API_KEY",
        variables: {
          userdetailsID: assetOwnerId,
          filter: { status: { eq: "Active" } },
          limit: limit,
        },
      });
      if (result.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
        let assetDatas = result.data.linkUsersAndSitesByUserdetailsID.items;
        nextToken = result.data.linkUsersAndSitesByUserdetailsID.nextToken;
        sites.push(assetDatas);
        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.linkUsersAndSitesByUserdetailsID,
            authMode: "API_KEY",
            variables: {
              userdetailsID: assetOwnerId,
              filter: { status: { eq: "Active" } },
              limit: limit,
              nextToken: nextToken,
            },
          });
          nextToken = results.data.linkUsersAndSitesByUserdetailsID.nextToken;
          if (results.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
            sites.push(results.data.linkUsersAndSitesByUserdetailsID.items);
          }
        }
        if (sites.length > 0) {
          const mergesites = sites.flat(1);
          let sitesforUsers = [];
          const promises = mergesites.map(async (item) => {
            return await client.graphql({
              query: queries.getSiteDetails,
              variables: { id: item.sitedetailsID },
              authMode: "API_KEY",
            });
          });
          Promise.all(promises).then((sitesData) => {
            sitesData.forEach((sites) => {
              if (sites.data.getSiteDetails !== null) {
                sitesforUsers.push(sites.data.getSiteDetails);
              }
            });

            if (selectedSiteGlobal) {
              const filterdata = sitesforUsers.filter(
                (item) => item.id === selectedSiteGlobal,
              );
              setsites(filterdata.filter((item) => item.status === "Active"));
            } else {
              setsites(
                sitesforUsers.filter((item) => item.status === "Active"),
              );
            }
            localStorage.setItem(
              "site",
              base64.encode(JSON.stringify(sitesforUsers)),
            );
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchSiteDetailsAO() {
    try {
      let nextToken = "";
      let sites = [];
      const result = await client.graphql({
        query: queries.siteDetailsByAssetownerID,
        variables: { assetownerID: LoginUserDetails.id, limit: 200000 },
        authMode: "API_KEY",
      });
      if (result.data.siteDetailsByAssetownerID.items.length > 0) {
        let assetDatas = result.data.siteDetailsByAssetownerID.items;
        nextToken = result.data.siteDetailsByAssetownerID.nextToken;
        sites.push(assetDatas);
        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.siteDetailsByAssetownerID,
            variables: {
              assetownerID: LoginUserDetails.id,
              limit: 200000,
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          nextToken = results.data.siteDetailsByAssetownerID.nextToken;
          if (results.data.siteDetailsByAssetownerID.items.length > 0) {
            sites.push(results.data.siteDetailsByAssetownerID.items);
          }
        }
        if (sites.length > 0) {
          const mergeSites = sites.flat(1);
          if (selectedSiteGlobal) {
            const filterdata = mergeSites.filter(
              (item) => item.id === selectedSiteGlobal,
            );
            setsites(filterdata.filter((item) => item.status === "Active"));
          } else {
            setsites(mergeSites.filter((item) => item.status === "Active"));
          }
          SiteData.setSiteData(mergeSites);
          localStorage.setItem(
            "site",
            base64.encode(JSON.stringify(mergeSites)),
          );
        }
      } else {
        setsites([]);
      }
    } catch (error) {
      console.error(error);
      setsites([]);
    }
  }

  async function fetchSitesforglobal() {
    try {
      let nextToken = "";
      let assets = [];
      const result = await client.graphql({
        query: queries.linkUsersAndSitesBySitedetailsID,
        authMode: "API_KEY",
        variables: {
          sitedetailsID: selectedSiteGlobal,
          filter: { status: { eq: "Active" } },
          limit: limit,
        },
      });
      if (result.data.linkUsersAndSitesBySitedetailsID.items.length > 0) {
        let assetDatas = result.data.linkUsersAndSitesBySitedetailsID.items;
        nextToken = result.data.linkUsersAndSitesBySitedetailsID.nextToken;
        assets.push(assetDatas);
        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.linkUsersAndSitesBySitedetailsID,
            authMode: "API_KEY",
            variables: {
              sitedetailsID: selectedSiteGlobal,
              filter: { status: { eq: "Active" } },
              limit: limit,
              nextToken: nextToken,
            },
          });
          if (results.data.linkUsersAndSitesBySitedetailsID.items.length > 0) {
            nextToken = results.data.linkUsersAndSitesBySitedetailsID.nextToken;
            assets.push(results.data.linkUsersAndSitesBySitedetailsID.items);
          } else {
            nextToken = null;
          }
        }
        if (assets.length > 0) {
          setspglobal(assets.flat(1));
        }
      } else {
        setspglobal([]);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (selectedSiteGlobal) {
      fetchSitesforglobal();
    }
  }, [selectedSiteGlobal]);

  const listSPDetails = async (DateRange) => {
    setIsLoading(true);
    let serviceProviders = [];
    if (LoginUserGroup === "admin") {
      setIsLoading(true);
      const response = await client.graphql({
        query: mergedQueries.listSPSUUserDetails,
        authMode: "API_KEY",
        variables: { limit: limit, userGroup: "electrician" },
      });

      if (response.data?.listSPUserDetails?.items?.length > 0) {
        const spUser = response.data.listSPUserDetails.items;
        const sitesfilter = spUser.filter((item) => {
          const _matchSites = spglobal?.find(
            (user) => user.userdetailsID === item?.id,
          );
          if (_matchSites) return item;
        });

        const sortedItems = selectedSiteGlobal
          ? sitesfilter.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
            )
          : spUser.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
            );

        const spDetails = sortedItems;
        if (DateRange === "This Week") {
          serviceProviders = spDetails.filter((item) => {
            const createdAtDate = moment(item.createdAt);
            return (
              createdAtDate.isSameOrAfter(
                moment(startOfWeek, "DD/MM/YYYY"),
                "day",
              ) &&
              createdAtDate.isSameOrBefore(
                moment(endOfWeek, "DD/MM/YYYY"),
                "day",
              )
            );
          });
        } else if (DateRange === "This Month") {
          serviceProviders = spDetails.filter((item) => {
            const createdAtDate = moment(item.createdAt);
            return createdAtDate.isBetween(
              moment(startOfMonth, "DD/MM/YYYY"),
              moment(endOfMonth, "DD/MM/YYYY"),
              null,
              "[]",
            );
          });
        } else if (DateRange === "Today") {
          serviceProviders = spDetails.filter(
            (item) =>
              moment(item.createdAt).format("YYYY-MM-DD") ===
              moment(new Date()).format("DD/MM/YYYY"),
          );
        } else if (DateRange === "This Year") {
          serviceProviders = spDetails.filter((item) => {
            const createdAtDate = moment(item.createdAt);
            return createdAtDate.isBetween(
              moment(startOfThisYear, "DD/MM/YYYY"),
              moment(endOfThisYear, "DD/MM/YYYY"),
              null,
              "[]",
            );
          });
        } else if (DateRange === "Custom") {
          serviceProviders = spDetails.filter((item) => {
            const createdAtDate = moment(item.createdAt);
            return createdAtDate.isBetween(
              moment(startDate, "DD/MM/YYYY"),
              moment(endDate, "DD/MM/YYYY"),
              null,
              "[]",
            );
          });
        } else if (DateRange === "All Time") {
          serviceProviders = spDetails;
        }

        setlistofServiceProviders(serviceProviders);
        setCollection(cloneDeep(serviceProviders.slice(0, countPerPage)));
        setIsLoading(false);
      } else {
        setlistofServiceProviders([]);
        setCollection([]);
        setIsLoading(false);
      }
    } else if (
      LoginUserGroup === "site_user" ||
      LoginUserGroup === "electrician"
    ) {
      setIsLoading(true);
      const dataDetails = await client.graphql({
        query: queries.linkUsersAndSitesByUserdetailsID,
        authMode: "API_KEY",
        variables: {
          userdetailsID: LoginUserDetails.id,
          filter: { status: { eq: "Active" } },
          limit: 100000,
        },
      });

      if (dataDetails.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
        const siteDetails =
          dataDetails.data.linkUsersAndSitesByUserdetailsID.items;
        const siteglobal = siteDetails.filter(
          (item) => item.sitedetailsID === selectedSiteGlobal,
        );
        const sitesss = selectedSiteGlobal ? siteglobal : siteDetails;
        let userIds = [];

        if (sitesss.length > 0) {
          await Promise.all(
            sitesss.map(async (site) => {
              let nextToken1 = "";
              const getSiteIds = await client.graphql({
                query: queries.linkUsersAndSitesBySitedetailsID,
                authMode: "API_KEY",
                variables: {
                  sitedetailsID: site.sitedetailsID,
                  filter: { status: { eq: "Active" } },
                },
              });
              if (
                getSiteIds.data.linkUsersAndSitesBySitedetailsID.items.length >
                0
              ) {
                nextToken1 =
                  getSiteIds.data.linkUsersAndSitesBySitedetailsID.nextToken;
                userIds.push(
                  getSiteIds.data.linkUsersAndSitesBySitedetailsID.items,
                );
                while (nextToken1 !== null) {
                  const getSiteIds1 = await client.graphql({
                    query: queries.linkUsersAndSitesBySitedetailsID,
                    authMode: "API_KEY",
                    variables: {
                      sitedetailsID: site.sitedetailsID,
                      filter: { status: { eq: "Active" } },
                      nextToken: nextToken1,
                    },
                  });
                  if (
                    getSiteIds1.data.linkUsersAndSitesBySitedetailsID.items
                      .length > 0
                  ) {
                    nextToken1 =
                      getSiteIds1.data.linkUsersAndSitesBySitedetailsID
                        .nextToken;
                    userIds.push(
                      getSiteIds1.data.linkUsersAndSitesBySitedetailsID.items,
                    );
                  } else {
                    nextToken1 = null;
                  }
                }
              }
            }),
          );

          if (userIds.length > 0) {
            const mergeUserIds = userIds.flat(1);
            const response1 = await client.graphql({
              query: queries.listSPUserDetails,
              authMode: "API_KEY",
              variables: {
                filter: { userGroup: { eq: "electrician" } },
                limit: 200000,
              },
            });

            if (response1.data.listSPUserDetails.items.length > 0) {
              const spDetails2 = response1.data.listSPUserDetails.items.filter(
                (item) => {
                  const _matchSites = mergeUserIds?.find(
                    (user) => user.userdetailsID === item?.id,
                  );
                  if (_matchSites) return item;
                },
              );

              const sortedItems = spDetails2.sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
              );
              const spDetails = sortedItems;

              if (spDetails.length > 0) {
                if (DateRange === "This Week") {
                  serviceProviders = spDetails.filter((item) => {
                    const createdAtDate = moment(item.createdAt);
                    return (
                      createdAtDate.isSameOrAfter(
                        moment(startOfWeek, "DD/MM/YYYY"),
                        "day",
                      ) &&
                      createdAtDate.isSameOrBefore(
                        moment(endOfWeek, "DD/MM/YYYY"),
                        "day",
                      )
                    );
                  });
                } else if (DateRange === "This Month") {
                  serviceProviders = spDetails.filter((item) => {
                    const createdAtDate = moment(item.createdAt);
                    return createdAtDate.isBetween(
                      moment(startOfMonth, "DD/MM/YYYY"),
                      moment(endOfMonth, "DD/MM/YYYY"),
                      null,
                      "[]",
                    );
                  });
                } else if (DateRange === "Today") {
                  serviceProviders = spDetails.filter(
                    (item) =>
                      moment(item.createdAt).format("YYYY-MM-DD") ===
                      moment(new Date()).format("DD/MM/YYYY"),
                  );
                } else if (DateRange === "This Year") {
                  serviceProviders = spDetails.filter((item) => {
                    const createdAtDate = moment(item.createdAt);
                    return createdAtDate.isBetween(
                      moment(startOfThisYear, "DD/MM/YYYY"),
                      moment(endOfThisYear, "DD/MM/YYYY"),
                      null,
                      "[]",
                    );
                  });
                } else if (DateRange === "Custom") {
                  serviceProviders = spDetails.filter((item) => {
                    const createdAtDate = moment(item.createdAt);
                    return createdAtDate.isBetween(
                      moment(startDate, "DD/MM/YYYY"),
                      moment(endDate, "DD/MM/YYYY"),
                      null,
                      "[]",
                    );
                  });
                } else if (DateRange === "All Time") {
                  serviceProviders = spDetails;
                }

                await Promise.all(
                  serviceProviders.map(async (item) => {
                    const usersDetails = await client.graphql({
                      query: queries.getUserDetails,
                      authMode: "API_KEY",
                      variables: { id: item.id },
                    });
                    if (usersDetails.data.getUserDetails !== null) {
                      item.username = usersDetails.data.getUserDetails.username;
                    }
                  }),
                );

                setlistofServiceProviders(serviceProviders);
                setCollection(
                  cloneDeep(serviceProviders.slice(0, countPerPage)),
                );
                setIsLoading(false);
              } else {
                setlistofServiceProviders([]);
                setCollection([]);
                setIsLoading(false);
              }
            }
          } else {
            setlistofServiceProviders([]);
            setCollection([]);
            setIsLoading(false);
          }
        } else {
          setlistofServiceProviders([]);
          setCollection([]);
          setIsLoading(false);
        }
      } else {
        setlistofServiceProviders([]);
        setCollection([]);
        setIsLoading(false);
      }
    } else {
      setIsLoading(true);
      if (localStorage.getItem("electricianlist") !== null) {
        let electdata = JSON.parse(
          base64.decode(localStorage.getItem("electricianlist")),
        );
        if (electdata.length > 0) {
          await Promise.all(
            electdata.map(async (item) => {
              const usersDetails = await client.graphql({
                query: queries.getUserDetails,
                authMode: "API_KEY",
                variables: { id: item.id },
              });
              if (usersDetails.data.getUserDetails !== null) {
                item.username = usersDetails.data.getUserDetails.username;
              }
            }),
          );
          const sortedItems = electdata.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          );
          setlistofServiceProviders(sortedItems);
          setCollection(cloneDeep(sortedItems.slice(0, countPerPage)));
          setIsLoading(false);
        } else {
          setlistofServiceProviders([]);
          setCollection(cloneDeep([].slice(0, countPerPage)));
          setIsLoading(false);
        }
      } else {
        let sites = JSON.parse(base64.decode(localStorage.getItem("site")));
        const filterSites = sites.filter(
          (item) => item.id === selectedSiteGlobal,
        );
        const activesites = sites.filter((item) => item.status === "Active");
        const filtersitesss = selectedSiteGlobal ? filterSites : activesites;

        try {
          if (filtersitesss.length > 0) {
            const siteIds = filtersitesss
              .filter((site) => site.status === "Active")
              .map((site) => site.id);
            const chunkArray = (arr, size) => {
              const chunks = [];
              for (let i = 0; i < arr.length; i += size) {
                chunks.push(arr.slice(i, i + size));
              }
              return chunks;
            };
            const siteIdChunks = chunkArray(siteIds, 50);
            let allElectricians = [];

            const chunkPromises = siteIdChunks.map((chunk) => {
              return client.graphql({
                query: queries.getSiteUsersAndElectricians,
                variables: { siteIds: chunk, onDateRange: "" },
                authMode: "API_KEY",
              });
            });

            const chunkResults = await Promise.all(chunkPromises);
            chunkResults.forEach((results) => {
              const summaries = results.data.getSiteUsersAndElectricians;
              const electricians = summaries?.electrician || [];
              allElectricians.push(...electricians);
            });

            const uniqueElectricians = Array.from(
              new Map(
                allElectricians.map((user) => [user.id || user.userID, user]),
              ).values(),
            );
            localStorage.setItem(
              "electricianlist",
              base64.encode(JSON.stringify(uniqueElectricians)),
            );

            await Promise.all(
              uniqueElectricians.map(async (item) => {
                try {
                  const usersDetails = await client.graphql({
                    query: queries.getUserDetails,
                    authMode: "API_KEY",
                    variables: { id: item.id },
                  });
                  if (usersDetails.data.getUserDetails !== null) {
                    item.username = usersDetails.data.getUserDetails.username;
                  }
                } catch (err) {
                  console.warn(
                    `Failed to fetch user details for ${item.id}`,
                    err,
                  );
                }
              }),
            );

            const sortedItems = uniqueElectricians.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
            );
            setlistofServiceProviders(sortedItems);
            setCollection(cloneDeep(sortedItems.slice(0, countPerPage)));
            setIsLoading(false);
            return uniqueElectricians;
          } else {
            setlistofServiceProviders([]);
            setCollection(cloneDeep([].slice(0, countPerPage)));
            setIsLoading(false);
            return [];
          }
        } catch (error) {
          console.error("Error fetching user summaries:", error);
          setlistofServiceProviders([]);
          setCollection(cloneDeep([].slice(0, countPerPage)));
          setIsLoading(false);
          return [];
        }
      }
    }
  };

  const globalSearch = (searchValue) => {
    let filteredData = listofServiceProviders.filter((row) => {
      const username = getUsername(row.id);
      const company = getUsercompnay(row.id);
      const licence = getCompnayLicence(row.id);
      return (
        row.fname?.toLowerCase().includes(searchValue.toLowerCase()) ||
        row.lname?.toLowerCase().includes(searchValue.toLowerCase()) ||
        row.status?.toLowerCase().includes(searchValue.toLowerCase()) ||
        row.email?.toLowerCase().includes(searchValue.toLowerCase()) ||
        row.mobile?.toLowerCase().includes(searchValue.toLowerCase()) ||
        moment(row.createdAt)
          .format("DD/MM/YYYY")
          ?.toLowerCase()
          .includes(searchValue.toLowerCase()) ||
        username?.toLowerCase().includes(searchValue.toLowerCase()) ||
        licence?.toLowerCase().includes(searchValue.toLowerCase()) ||
        company?.toLowerCase().includes(searchValue.toLowerCase())
      );
    });
    return cloneDeep(filteredData);
  };

  useEffect(() => {
    if (!value) {
      setCollection(cloneDeep(listofServiceProviders.slice(0, countPerPage)));
      setFilteredData([]);
    } else {
      const filteredDataResult = globalSearch(value);
      setFilteredData(filteredDataResult);
      setCollection(cloneDeep(filteredDataResult.slice(0, countPerPage)));
    }
  }, [value]);

  const updatePage = (p) => {
    setCurrentPage(p);
    const to = countPerPage * p;
    const from = to - countPerPage;

    if (selected) {
      const pageData = customdata.slice(from, to);
      setCollection(cloneDeep(pageData));
    } else if (!value) {
      setCollection(cloneDeep(listofServiceProviders.slice(from, to)));
    } else {
      const filteredDataResult = globalSearch(value);
      const pageData = filteredDataResult.slice(from, to);
      setCollection(cloneDeep(pageData));
    }
  };

  const handleUserGroupChange = (event) => {
    const selectedUserGroup = event.target.value;
    if (selectedUserGroup === "") {
      setCollection(cloneDeep(listofServiceProviders.slice(0, countPerPage)));
    } else {
      const filteredSPs = listofServiceProviders.filter(
        (sp) => sp.userGroup === selectedUserGroup,
      );
      setCollection(cloneDeep(filteredSPs.slice(0, countPerPage)));
    }
  };

  const [selectedOption, setSelectedOption] = useState("");
  const [selected, setSelected] = useState(false);
  const [dateRange1, setDateRange1] = useState([new Date(), new Date()]);

  const currentDate = new Date();
  const currentDayOfWeek = currentDate.getDay();
  const startOfWeek = moment(
    new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() - currentDayOfWeek,
    ),
  ).format("DD/MM/YYYY");
  const endOfWeek = moment(
    new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + (6 - currentDayOfWeek),
    ),
  ).format("DD/MM/YYYY");
  const startOfMonth = moment(
    new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
  ).format("DD/MM/YYYY");
  const endOfMonth = moment(
    new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0),
  ).format("DD/MM/YYYY");
  const startOfThisYear = moment(
    new Date(currentDate.getFullYear(), 0, 1),
  ).format("DD/MM/YYYY");
  const endOfThisYear = moment(
    new Date(currentDate.getFullYear(), 11, 31),
  ).format("DD/MM/YYYY");

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const handleDateRangeSelected = (range) => {
    setDateRange1(range);
  };

  const onDateRangeSelected = (range) => {
    handleDateRangeSelected(range);
  };

  function DateRangePicker({ onDateRangeSelected }) {
    const handleOptionChange = (event) => {
      setSelectedOption(event.target.value);
      switch (event.target.value) {
        case "Today":
          onDateRangeSelected(getTodayRange());
          break;
        case "This Week":
          onDateRangeSelected(getWeekRange());
          break;
        case "This Month":
          onDateRangeSelected(getMonthRange());
          break;
        case "This Year":
          onDateRangeSelected(getThisYearRange());
          break;
        case "All Time":
          onDateRangeSelected(getAllTimeRange());
          break;
        case "Custom":
          onDateRangeSelected(getCustomRange());
          break;
        default:
          break;
      }
    };

    const getTodayRange = () => {
      setSelected(true);
      const filteredDatad = listofServiceProviders.filter(
        (item) =>
          moment(item.createdAt).format("DD/MM/YYYY") ===
          moment(new Date()).format("DD/MM/YYYY"),
      );
      setcustomdata(filteredDatad);
      setCollection(cloneDeep(filteredDatad.slice(0, countPerPage)));
    };

    const getCustomRange = () => {
      setSelected(true);
    };

    const getAllTimeRange = () => {
      setSelected(false);
      listSPDetails("All Time");
    };

    const getWeekRange = () => {
      setSelected(true);
      const filteredDatad = listofServiceProviders.filter((item) => {
        const createdAtDate = moment(item.createdAt);
        return (
          createdAtDate.isSameOrAfter(
            moment(startOfWeek, "DD/MM/YYYY"),
            "day",
          ) &&
          createdAtDate.isSameOrBefore(moment(endOfWeek, "DD/MM/YYYY"), "day")
        );
      });
      setcustomdata(filteredDatad);
      setCollection(cloneDeep(filteredDatad.slice(0, countPerPage)));
    };

    const getMonthRange = () => {
      setSelected(true);
      const filteredDatad = listofServiceProviders.filter((item) => {
        const createdAtDate = moment(item.createdAt);
        return createdAtDate.isBetween(
          moment(startOfMonth, "DD/MM/YYYY"),
          moment(endOfMonth, "DD/MM/YYYY"),
          null,
          "[]",
        );
      });
      setcustomdata(filteredDatad);
      setCollection(cloneDeep(filteredDatad.slice(0, countPerPage)));
    };

    const getThisYearRange = () => {
      setSelected(true);
      const filteredDatad = listofServiceProviders.filter((item) => {
        const createdAtDate = moment(item.createdAt);
        return createdAtDate.isBetween(
          moment(startOfThisYear, "DD/MM/YYYY"),
          moment(endOfThisYear, "DD/MM/YYYY"),
          null,
          "[]",
        );
      });
      setcustomdata(filteredDatad);
      setCollection(cloneDeep(filteredDatad.slice(0, countPerPage)));
    };

    return (
      <div className="daterange-card">
        <Row>
          <Col xs="6">
            <FormGroup>
              <Input
                type="select"
                value={selectedOption}
                onChange={handleOptionChange}
              >
                <option value="All Time">All Time</option>
                <option value="Today">Today</option>
                <option value="This Week">This Week</option>
                <option value="This Month">This Month</option>
                <option value="This Year">This Year</option>
                <option value="Custom">Custom</option>
              </Input>
            </FormGroup>
          </Col>
          <Col xs="6">
            <FormGroup>
              {selectedOption === "Custom" && (
                <Fragment>
                  <Row className="d-flex justify-content-end">
                    <Col xl="6">
                      <div className="daterange-card">
                        <div className="mb-3">
                          <FormGroup>
                            <DatePicker
                              className="form-control digits"
                              selectsRange={true}
                              startDate={startDate}
                              endDate={endDate}
                              onChange={(d) => {
                                setDateRange(d);
                                const [newStartDate, newEndDate] = d;
                                if (newStartDate && newEndDate) {
                                  setSelected(true);
                                  const filteredDatad =
                                    listofServiceProviders.filter((item) => {
                                      const createdAtDate = moment(
                                        item.createdAt,
                                      );
                                      return (
                                        createdAtDate.isSameOrAfter(
                                          moment(newStartDate, "DD/MM/YYYY"),
                                          "day",
                                        ) &&
                                        createdAtDate.isSameOrBefore(
                                          moment(newEndDate, "DD/MM/YYYY"),
                                          "day",
                                        )
                                      );
                                    });
                                  setcustomdata(filteredDatad);
                                  setCollection(
                                    cloneDeep(
                                      filteredDatad.slice(0, countPerPage),
                                    ),
                                  );
                                } else {
                                  setSelected(false);
                                  setcustomdata([]);
                                  setCollection(
                                    cloneDeep(
                                      listofServiceProviders.slice(
                                        0,
                                        countPerPage,
                                      ),
                                    ),
                                  );
                                }
                              }}
                              isClearable={true}
                              placeholderText="Enter Date Range"
                              dateFormat="dd-MM-yyyy"
                            />
                          </FormGroup>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Fragment>
              )}
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  }

  const selectSites = (d) => {
    setsitesSelected(d);
    if (d.length > 0) {
      setSiteError(false);
    } else {
      setSiteError(true);
    }
  };

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    const params = {
      ACL: "public-read",
      Body: file,
      Bucket: S3_BUCKET,
      Key: `public/${COMPANY_FOLDER}/${file.name}`,
    };
    myBucket
      .putObject(params)
      .on("httpUploadProgress", () => {
        const filedetails = [{ fileName: file.name, type: file.type }];
        setSelectedFile(filedetails[0].fileName);
      })
      .send((err) => {
        if (err) console.error(err);
      });
  };

  const handleCheck = (event) => {
    var updatedList = [...permissions];
    if (event.target.checked) {
      updatedList = [...permissions, event.target.value];
    } else {
      updatedList.splice(permissions.indexOf(event.target.value), 1);
    }
    setPermissions(updatedList);
  };

  const isChecked = (item) =>
    permissions.includes(item) ? "checked-item" : "not-checked-item";

  const handleSelectAllSites = (event) => {
    try {
      if (event.target.checked) {
        setsitesSelected(sites);
      } else {
        setsitesSelected([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const renderList = (
    <Fragment>
      <Container fluid={true} className="ecommerce-dash">
        <br></br>
        <Row>
          <DateRangePicker
            onDateRangeSelected={onDateRangeSelected}
          ></DateRangePicker>
        </Row>
        <Row>
          <Col md="12" className="project-list">
            <Card className="custom-card">
              <CardHeader>
                <Row>
                  <Col md="4">
                    <InputGroup>
                      <span className="input-group-text">
                        <i className="icon-search"></i>
                      </span>
                      <Input
                        type="search"
                        placeholder="Search Service Providers.."
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                      />
                    </InputGroup>
                  </Col>
                  <Col sm="4" className="text-end">
                    <Form.Select
                      name="userGroup"
                      onChange={handleUserGroupChange}
                    >
                      <option value="">Choose....</option>
                      <option value="electrician">Electrician</option>
                      <option value="cleaner">Cleaner</option>
                    </Form.Select>
                  </Col>
                  <Col sm="4" className="text-end">
                    {LoginUserGroup != "admin" && (
                      <Button onClick={handleShowInvite}>
                        {" "}
                        + Add Service Provider{" "}
                      </Button>
                    )}
                  </Col>
                </Row>
              </CardHeader>
              <div className="card-block row">
                <Col sm="12" lg="12" xl="12">
                  <div className="table-responsive">
                    {isLoading ? (
                      <LoadingSpinner />
                    ) : (
                      <Table className="table-striped table-de">
                        <thead className="custom-table-head">
                          <tr>
                            <th scope="col">Company</th>
                            <th scope="col">Electrcal Licence Number</th>
                            <th scope="col">Email</th>
                            <th scope="col">UserName</th>
                            <th scope="col">Added On</th>
                            <th scope="col">Approval Status</th>
                            <th scope="col">Approve</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody className="trhover">
                          {collection.length > 0 ? (
                            collection.map((item) => (
                              <tr key={item.id}>
                                <td>
                                  {getUsercompnay(item.spcompanydetailsID)}
                                </td>
                                <td>{item.license}</td>
                                <td>{item.email}</td>
                                <td>
                                  {LoginUserGroup === "admin"
                                    ? item.UserDetails?.username
                                    : item.username}
                                </td>
                                <td>
                                  {moment(item.createdAt).format("DD/MM/YYYY")}
                                </td>
                                <td>{item.status}</td>
                                <td>
                                  <Media body className="icon-state switch-sm">
                                    <Label className="switch">
                                      <input
                                        type="checkbox"
                                        onChange={(e) => handleChange(item, e)}
                                      />
                                      <span
                                        className={ApproveStatus(item.status)}
                                      ></span>
                                    </Label>
                                  </Media>
                                </td>
                                <td>
                                  <Btn
                                    attrBtn={{
                                      className: "btn-outline-* btn-xs m-r-5",
                                      color: "primary",
                                      title: "Permissions",
                                      onClick: () => handleShow(item),
                                    }}
                                  >
                                    <i className="fa fa-check-square"></i>
                                  </Btn>
                                  <Btn
                                    attrBtn={{
                                      className: "btn-outline-* btn-xs m-r-5",
                                      color: "primary",
                                      title: "Edit",
                                      onClick: () => handleEdit(item),
                                    }}
                                  >
                                    <i className="fa fa-edit "></i>
                                  </Btn>
                                  <Btn
                                    attrBtn={{
                                      className: "btn-outline-* btn-xs m-r-5",
                                      color: "primary",
                                      title: "View",
                                      onClick: () => handleView(item),
                                    }}
                                  >
                                    <i className="fa fa-eye"></i>{" "}
                                  </Btn>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    )}
                  </div>
                </Col>
              </div>
              <CardFooter className="row">
                <Pagination
                  className="p-t-10"
                  pageSize={countPerPage}
                  onChange={updatePage}
                  current={currentPage}
                  total={
                    value
                      ? filteredData.length
                      : selected
                        ? customdata.length
                        : listofServiceProviders.length
                  }
                  showTotal={(total, range) =>
                    `${range[0]} - ${range[1]} of ${total} items`
                  }
                />
              </CardFooter>
            </Card>

            <Modal show={show} size="lg" onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>
                  Edit Permissions for{" "}
                  {itemforPermission.fname && itemforPermission.lname
                    ? itemforPermission.fname + " " + itemforPermission.lname
                    : itemforPermission.email}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col md="6 mb-3">
                    <Label>Choose Permissions</Label>
                    <ScrollBar
                      className="vertical-scroll ps-container ps-theme-default ps-active-y"
                      style={{
                        height: "300px",
                        border: "1px solid #efefef",
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      {permissionsList.map((item, index) => (
                        <Label className="d-block" key={index}>
                          <input
                            value={item}
                            type="checkbox"
                            onChange={handleCheck}
                            checked={permissions.includes(item)}
                          />
                          <span className={isChecked(item)}>{item}</span>
                        </Label>
                      ))}
                    </ScrollBar>
                  </Col>
                  <Col md="6 mb-3">
                    <Label>Selected Permissions</Label>
                    <ScrollBar
                      className="vertical-scroll ps-container ps-theme-default ps-active-y"
                      style={{
                        height: "300px",
                        border: "1px solid #efefef",
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      {permissions.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ScrollBar>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={() => editPermissions()}>
                  {" "}
                  Save Changes{" "}
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={showInvite} size="lg" onHide={handleCloseInvite}>
              <Form
                className="needs-validation"
                noValidate=""
                onSubmit={handleSubmit(onSubmit)}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Add new Service Providers</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col md="4 mb-3">
                      <Label>First Name</Label>
                      <input
                        className="form-control"
                        name="firstName"
                        type="text"
                        placeholder="First Name"
                        {...register("firstName", { required: true })}
                      />
                      <span>
                        {errors.firstName && "First Name is required"}
                      </span>
                    </Col>
                    <Col md="4 mb-3">
                      <Label>Last Name</Label>
                      <input
                        className="form-control"
                        name="lastName"
                        type="text"
                        placeholder="Last Name"
                        {...register("lastName", { required: true })}
                      />
                      <span>{errors.lastName && "Last Name is required"}</span>
                    </Col>
                    <Col md="4 mb-3">
                      <Label>License #</Label>
                      <input
                        className="form-control"
                        name="licence"
                        type="text"
                        placeholder="License #"
                        {...register("licence", { required: true })}
                      />
                      <span>{errors.licence && "License # is required"}</span>
                    </Col>
                    <Col md="6 mb-3">
                      <Label>E-mail</Label>
                      <input
                        className="form-control"
                        name="email"
                        type="email"
                        placeholder="E-mail"
                        {...register("email", { required: true })}
                      />
                      <span>{errors.email && "email is required"}</span>
                    </Col>
                    <Col md="6 mb-3">
                      <Label>Select Service Provider Company</Label>
                      <select
                        className="form-select"
                        name="company"
                        {...register("company", { required: !showAddCompany })}
                        defaultValue={newCompanyId}
                      >
                        <option value="">Select Company</option>
                        {(LoginUserGroup === "spao"
                          ? spCompany
                          : spcompanyname
                        ).map((item) => (
                          <option value={item.id} key={item.id}>
                            {item.companyName}
                          </option>
                        ))}
                      </select>
                      <span>
                        {errors.company &&
                          "Service Provider Company is required"}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6 mb-3 pt-3"></Col>
                    <Col md="6 mb-3 pt-3">
                      <Label>OR </Label>
                      <br />
                      <a
                        onClick={() => setShowAddCompany(!showAddCompany)}
                        className="btn btn-primary m-l-10"
                      >
                        {!showAddCompany ? "Create New Company" : "Cancel"}
                      </a>
                    </Col>
                  </Row>
                  <Row>
                    {showAddCompany && (
                      <Col md="12">
                        <H3>Add New Company</H3>
                        <Row>
                          <Col md="6 mb-3">
                            <Label>Company Name</Label>
                            <input
                              className="form-control"
                              name="companyname"
                              type="text"
                              placeholder="Company Name"
                              {...register("companyname", { required: true })}
                            />
                            <span>
                              {errors.companyname && "Company Name is required"}
                            </span>
                          </Col>
                          <Col md="6 mb-3">
                            <Label>Business Number</Label>
                            <input
                              className="form-control"
                              name="businessNumber"
                              type="text"
                              placeholder="Business Number"
                              {...register("businessNumber", {
                                required: false,
                              })}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6 mb-3">
                            <Label>E-Mail</Label>
                            <input
                              className="form-control"
                              type="email"
                              name="companyEmail"
                              placeholder="Email"
                              {...register("companyEmail", { required: true })}
                            />
                            <span>
                              {errors.companyEmail && "Email is required"}
                            </span>
                          </Col>
                          <Col md="6 mb-3">
                            <Label>Company Logo</Label>
                            <input
                              className="form-control"
                              name="companylogo"
                              type="file"
                              placeholder="Logo"
                              onChange={handleFileInput}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6 mb-3">
                            <Label>Choose Permissions</Label>
                            <ScrollBar
                              className="vertical-scroll ps-container ps-theme-default ps-active-y"
                              style={{
                                height: "300px",
                                border: "1px solid #efefef",
                                padding: "5px",
                                borderRadius: "5px",
                              }}
                            >
                              {permissionsList.map((item, index) => (
                                <Label className="d-block" key={index}>
                                  <input
                                    value={item}
                                    type="checkbox"
                                    onChange={handleCheck}
                                    checked={permissions.includes(item)}
                                  />
                                  <span className={isChecked(item)}>
                                    {item}
                                  </span>
                                </Label>
                              ))}
                            </ScrollBar>
                          </Col>
                          <Col md="6 mb-3">
                            <Label>Selected Permissions</Label>
                            <ScrollBar
                              className="vertical-scroll ps-container ps-theme-default ps-active-y"
                              style={{
                                height: "300px",
                                border: "1px solid #efefef",
                                padding: "5px",
                                borderRadius: "5px",
                              }}
                            >
                              {permissions.map((item, index) => (
                                <li key={index}>{item}</li>
                              ))}
                            </ScrollBar>
                          </Col>
                        </Row>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col>
                      <input
                        type="checkbox"
                        onChange={(event) => handleSelectAllSites(event)}
                      />{" "}
                      Select All Sites
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Label>Choose Sites</Label>
                      <Typeahead
                        id="rendering-example"
                        multiple={true}
                        options={sites}
                        labelKey={(sites) =>
                          `${sites.siteName} ,(${sites.unitNumber ? sites.unitNumber : ""})`
                        }
                        placeholder="Choose Sites"
                        onChange={(d) => selectSites(d)}
                        selected={sitesSelected}
                      />
                      {siteError ? (
                        <span>{"Selecting Site is required"}</span>
                      ) : (
                        ""
                      )}
                      {sitesSelected.length > 0 && (
                        <>
                          <Label>Selected Sites</Label>
                          <ScrollBar
                            className="vertical-scroll ps-container ps-theme-default ps-active-y"
                            style={{
                              height: "200px",
                              border: "1px solid #efefef",
                              padding: "1px",
                              borderRadius: "1px",
                            }}
                          >
                            {sitesSelected.map((item, index) => (
                              <Label className="d-block" key={index}>
                                <span>
                                  {item.siteName},{" (" + item.unitNumber + ")"}
                                </span>
                              </Label>
                            ))}
                          </ScrollBar>
                        </>
                      )}
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Btn attrBtn={{ color: "primary", disabled: loading }}>
                    {loading ? "Adding..." : "Add new SP"}
                  </Btn>
                  <Button variant="danger" onClick={handleCloseInvite}>
                    {" "}
                    Cancel{" "}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );

  return (
    <div>
      {renderList}
      {errorMessage && <div className="error">{errorMessage}</div>}
    </div>
  );
};

export default ServiceProviderDetails;
